//TODO::возращаем актуальный Studio если есть в маршруте то из маршрута иначе из state
import {Vue} from "vue-property-decorator";

export function getStudioId(that: Record<any, any>):any {
    const routeStudio = Number(Vue.router.currentRoute.params['Studio']);
    return routeStudio > 0 ? routeStudio : that.$store.state['salon_id'];
}
